module.exports = require("dropzone");